<template>
  <v-flex :class="classes">
    <div class="bm-field-label">{{ label }}</div>
    <div><slot /></div>
  </v-flex>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";

export default defineComponent({
  name: "BmField",
  props: {
    label: {
      type: String,
    },
    gridWidth: {
      type: Number,
      default: 12,
    },
  },
  setup(props) {
    return {
      classes: computed((): string[] => {
        if (props.gridWidth === 6) {
          return ["xs12", "sm6", "md6", "xl3"];
        } else {
          // default 12
          return ["xs12", "sm6", "md3"];
        }
      }),
    };
  },
});
</script>
